<template>
	<div>
		<footer id="store-footer" class="footer">
			<div class="columns">
				<div class="column">
					<div class="block">
						<h2>Contact <span>Zappos</span></h2>
						<div class="info">
							<ul>
								<li>
									<h4><BaseIcon class="footer-icon" icon="phone" />Telephone</h4>
									<a :href="phoneHref()"><p>{{storeLocation.contactPhone}}</p></a>
								</li>
								<li>
									<h4><BaseIcon class="footer-icon" icon="locationMarker" />Address</h4>
									<a :href="addressLink()"><p>{{displayAddress()}}</p></a>
								</li>
								<li>
									<h4><BaseIcon class="footer-icon" icon="email" />Email</h4>
									<a href="mailto:orders@zappospizza.com"><p>orders@zappospizza.com</p></a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="column">
					<div class="block">
						<h2>Follow <span>Zappos</span></h2>
						<div class="social-icon-container">
							<a class="flex" href="https://fb.com/zappospizzapdx" aria-label="Zappos on Facebook" target="_blank" rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="facebook" />
							</a>
							<a class="flex" href="https://twitter.com/zappospizza" aria-label="Zappos on Twitter" target="_blank" rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="twitter" />
							</a>
							<a class="flex" href="https://www.instagram.com/zappospizza" aria-label="Zappos on Instagram" target="_blank" rel="noopener">
								<BaseIcon :classNames="['social-icon']" icon="instagram" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
		<tp-footer />
	</div>
</template>

<script>
import TPFooter from '@/components/footer/TPFooter';
import footerMixin from '@Mixin/footerMixin';

export default {
	mixins: [footerMixin],
	components: {
		'tp-footer': TPFooter,
	},
	methods: {
		style() {
			const mobile = this.$isMobile;
			return {
				mobile,
				desktop: !mobile,
			};
		},
		phoneHref() {
			return `tel:+1${this.storeLocation.contactPhone}`;
		},
		displayAddress() {
			return `${this.storeLocation.address}`;
		},
		addressLink() {
			const hasAddress = this.storeLocation && this.storeLocation.addess;
			if (!hasAddress) {
				return '-';
			}
			const searchAddress = this.storeLocation.address.replace(/\s/g, '+');
			return `https://www.google.com/maps/place/${searchAddress}`;
		},
	},
};
</script>

<style lang="scss" scoped>
	@import '@style-vars';

	.flex {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.social-icon {
		font-size: 12px;
		color: #EC1C24;
	}

	.info {
		a {
			font-weight: 500;
			:hover {
				color: #EC1C24;
			}
		}
	}

	.social-icon-container {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
		max-width: 8em;
		a {
			cursor: pointer;
			width: 2em;
			height: 2em;
			border-radius: 50%;
			border: 1px solid lightgray;
			background-color: lightgray;
			&:hover {
				background-color: white;
				border-color: #EC1C24;
			}
		}
	}

	#store-footer {
		background-color: #ffffff;
		background-repeat: no-repeat;
		background-position: center center;
		padding: 40px;
		background-size: auto;
		min-height: 348px;
		&.desktop-size {
			margin-top: 40px;
			padding-bottom: 0;
		}
		&.mobile {
			position: relative;
			margin-top: 40px;
			padding-top: 0;
		}
		h4 {
			padding-bottom: 10px;
			display: block;
			color: #EC1C24;
		}
		li {
			padding: 3px 0px;
			margin-bottom: 20px;
		}
		.footer-icon {
			display: inline;
			margin-right: 10px;
		}
		.block {
			h2 {
				color: #2E2E2E;
				padding-bottom: 15px;
				font-weight: bold;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/footer/AppFooter.vue